export default "__VITE_ASSET__5OWe$K94__"